import React from 'react';
import { MapPin, Download, CheckCircle, Trophy } from 'lucide-react';
import { downloadCV } from '../../utils';
import './AboutSection.css';

const achievements = [
  { icon: Trophy, label: '3+ years experience in backend development', color: '#f59e0b' },
  { icon: CheckCircle, label: '100% on-time delivery record', color: '#10b981' },
];

const AboutSection = ({ isVisible }) => {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-grid about-grid-single">
          <div className={`about-content ${isVisible ? 'animate-slide-right' : 'opacity-0'}`}>
            <div className="about-header">
              <p className="about-label">About Me</p>
              <h2 className="about-title">
                <span className="gradient-text">About Me</span>
              </h2>
            </div>
            
            <p className="about-description">
              I'm an IT Engineering student at Damascus University specializing in AI. My expertise is building production-grade backend systems and RESTful APIs with Laravel and Django. I focus on creating scalable architectures, optimizing database performance, and implementing real-time features like chat systems and live tracking.
            </p>
            <p className="about-description-secondary">
              Strong in security (OAuth, OTP, JWT), DevOps (Docker, Linux), and crafting APIs that power modern applications. Always learning, always building.
            </p>

            <div className="about-achievements">
              {achievements.map((item, i) => {
                const Icon = item.icon;
                return (
                  <div key={i} className="about-achievement-item" style={{ '--ach-color': item.color }}>
                    <Icon size={16} className="about-achievement-icon" />
                    <span>{item.label}</span>
                  </div>
                );
              })}
            </div>
            
            <div className="about-info-grid">
              <div className="about-info-card glass">
                <div className="info-card-label">Location</div>
                <div className="info-card-value">
                  <MapPin size={16} />
                  Damascus, Syria
                </div>
              </div>
            </div>
            
            <div className="about-actions">
              <button 
                onClick={downloadCV}
                className="about-download-btn"
              >
                <Download size={18} />
                Download CV
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
